"use strict";
/*
 * Created on 09 02 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../../core/model/errors/conversions/ValidationResultConverter");

var index_1 = require("../../../core/utils/index");

var PriceTermination_1 = require("../../../price-termination/model/PriceTermination");

var SiteReleaseTermination_1 = require("../../model/price-termination/SiteReleaseTermination");

var SiteReleaseTerminationConverter_1 = require("./SiteReleaseTerminationConverter");
/**
 * <p>Implementation of {@link SiteReleaseTerminationConverter}.</p>
 *
 * @author Jaroslav Sevcik
 */


var SiteReleaseTerminationConverterImpl =
/*#__PURE__*/
function (_SiteReleaseTerminati) {
  _inherits(SiteReleaseTerminationConverterImpl, _SiteReleaseTerminati);

  function SiteReleaseTerminationConverterImpl(validationResultConverter) {
    var _this;

    _classCallCheck(this, SiteReleaseTerminationConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseTerminationConverterImpl).call(this));
    _this.validationResultConverter = validationResultConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SiteReleaseTerminationConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        name: source.name,
        state: source.state,
        terminationIssued: conversions.asObjectOpt(source, 'terminationIssued', function (v) {
          return conversions.fromDate(v);
        }),
        progressId: conversions.asObjectOpt(source, 'progressId', function (v) {
          return conversions.toDocumentReferenceId(v);
        }),
        validation: this.validationResultConverter.toDocument(source.validation, conversions)
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SiteReleaseTermination_1.SiteReleaseTermination(conversions.documentToClassId(source), conversions.asObject(source, 'name', function (v) {
        return index_1.Utils.asString(v);
      }), conversions.asEnum(source.state, PriceTermination_1.PriceTerminationState), conversions.asObjectOpt(source, 'terminationIssued', function (v) {
        return conversions.toDate(v);
      }), conversions.asObjectOpt(source, 'progressId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'validation', function (doc) {
        return _this2.validationResultConverter.toObject(doc, conversions);
      }));
    }
  }]);

  return SiteReleaseTerminationConverterImpl;
}(SiteReleaseTerminationConverter_1.SiteReleaseTerminationConverter);

SiteReleaseTerminationConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ValidationResultConverter_1.ValidationResultConverter])], SiteReleaseTerminationConverterImpl);
exports.SiteReleaseTerminationConverterImpl = SiteReleaseTerminationConverterImpl;